module.exports = __webpack_public_path__ + "img/black-cat.b823f9ec.png";